import React, { useEffect } from 'react';

const CHAT_BASE_URL = `${process.env.CHAT_BASE_URL}`;
const CHAT_TOKEN = `${process.env.CHAT_TOKEN}`;

const ChatwootSDK = () => {
  useEffect(() => {
    const t = 'script';
    const d = document;
    const g = d.createElement(t);
    const s = d.getElementsByTagName(t)[0];
    g.src = CHAT_BASE_URL + '/packs/js/sdk.js';
    g.async = true;
    s.parentNode.insertBefore(g, s);
    // eslint-disable-next-line prefer-arrow/prefer-arrow-functions
    g.onload = function () {
      window.chatwootSDK.run({
        websiteToken: CHAT_TOKEN,
        baseUrl: CHAT_BASE_URL,
      });
    };
  }, []);

  return <></>;
};

export { ChatwootSDK };
